<!-- پس‌زمینه شیشه مایع متحرک - در پشت همه صفحات ثابت می‌ماند -->
<div class="liquid-background" aria-hidden="true">
  <div class="liquid-background__blob liquid-background__blob--1"></div>
  <div class="liquid-background__blob liquid-background__blob--2"></div>
  <div class="liquid-background__blob liquid-background__blob--3"></div>
</div>

<!-- Skip to main content link for keyboard accessibility -->
<a href="#main-content" class="skip-link">به محتوای اصلی بروید</a>

<main id="main-content" class="app-shell" [class.app-shell--with-nav]="isLoggedIn && !appUiState.hideBottomNav()">
  <router-outlet />
</main>

@if (isLoggedIn && !appUiState.hideBottomNav()) {
  <app-bottom-nav />
}

<!-- PWA Components -->
<app-offline-indicator />
<app-sw-update-notification />
<app-sync-status />
<app-pwa-install-banner />

<!-- Global toast container for user feedback -->
<app-toast-container />

<!-- Global aria-live announcer for dynamic status messages -->
<div id="announcer" aria-live="polite" aria-atomic="true" class="visually-hidden" role="status"></div>
<div id="announcer-assertive" aria-live="assertive" aria-atomic="true" class="visually-hidden" role="alert"></div>

<!--
  محل رندر سراسری مودال‌ها/پاپ‌آپ‌ها (date-picker، time-picker، bottom-sheet ثبت پریود).
  این ng-container در بالاترین سطح DOM (بیرون از همه app-glass-card هایی که
  isolation:isolate دارند) قرار دارد، بنابراین z-index مودال همیشه واقعاً
  بالاترین لایه صفحه است و هیچ کارتی نمی‌تواند رویش بیفتد.
-->
@if (overlayService.activeTemplate()) {
  <ng-container [ngTemplateOutlet]="overlayService.activeTemplate()" />
}
